// components/canvasPointerUtils.ts
import React from 'react';

export const getCanvasMouseCoordinates = (
  event: React.MouseEvent | React.TouchEvent,
  canvas: HTMLCanvasElement,
  options?: { clamp?: boolean }
) => {
  const isTouch = 'touches' in event;
  const touch = isTouch
    ? (event.touches.length > 0 ? event.touches[0] : event.changedTouches[0])
    : null;

  const clientX = isTouch ? touch!.clientX : (event as React.MouseEvent).clientX;
  const clientY = isTouch ? touch!.clientY : (event as React.MouseEvent).clientY;

  const rect = canvas.getBoundingClientRect();
  const imageAspectRatio = canvas.width / canvas.height;
  const containerAspectRatio = rect.width / rect.height;

  let drawX = 0;
  let drawY = 0;
  let drawW = rect.width;
  let drawH = rect.height;

  if (imageAspectRatio > containerAspectRatio) {
    drawH = rect.width / imageAspectRatio;
    drawY = (rect.height - drawH) / 2;
  } else {
    drawW = rect.height * imageAspectRatio;
    drawX = (rect.width - drawW) / 2;
  }

  const canvasX = clientX - rect.left - drawX;
  const canvasY = clientY - rect.top - drawY;

  const x = (canvasX / drawW) * canvas.width;
  const y = (canvasY / drawH) * canvas.height;

  if (options?.clamp) {
    return {
      x: Math.min(canvas.width, Math.max(0, x)),
      y: Math.min(canvas.height, Math.max(0, y)),
    };
  }

  return { x, y };
};
